import type { Product } from '../generated/graphql'
import { getProductHasTaxon } from './get-product-has-taxon'
import { claimOnlyTaxonCode } from '../constants'

export function getIsProductClaimOnly(product: Product | null) {
  if (!product) return false

  return getProductHasTaxon(product, claimOnlyTaxonCode)
}
